<template>
  <div class="home mt-3">
    <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
      <div class="d-flex align-items-center flex-wrap">
        <h2 class="mb-0 mr-3">Tareas Bulk</h2>
      </div>

      <div class="d-flex align-items-center flex-wrap mt-2 mt-sm-0">
        <button
          class="btn btn-sm btn-principal"
          data-toggle="collapse"
          href="#filtroscollapse"
          role="button"
          aria-expanded="false"
          aria-controls="filtroscollapse"
        >
          <i class="bi-filter"></i> Filtros
        </button>
      </div>
    </div>
    <div class="collapse mb-3" id="filtroscollapse">
      <div class="card card-body bg-light border-0 shadow-sm py-3 px-4">
        <div class="form-row align-items-end">
          <div class="form-group col mb-2">
            <label class="font-weight-bold small text-muted mb-1" for="tarea_select">Por Tarea</label>
            <input
              type="text"
              class="form-control"
              id="tarea_select"
              placeholder="Filtrar por tarea..."
              @keyup.enter="tareasBuscar()"
              v-model="tarea_sel"
              aria-label="Tarea"
            />
          </div>

          <div class="form-group col-md-3 mb-2">
            <label class="font-weight-bold small text-muted mb-1" for="enabled_select">Por Estado</label>
            <select
              class="form-control"
              v-model="tarea_activo"
              @change="tareasBuscar()"
              aria-label="Estado"
              id="enabled_select"
            >
              <option :value="null">Todos los estados</option>
              <option value="Completado">Completado</option>
              <option value="En Proceso">En Proceso</option>
              <option value="Finalizada con errores">Finalizada con errores</option>
              <option value="Sin ejecutar">Sin ejecutar</option>
            </select>
          </div>
          <div class="form-group col-auto mb-2">
            <button @click="tareasBuscar()" class="btn btn-info px-4">
              <i class="bi-search"></i> Buscar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="alert alert-success" role="alert" v-if="success">
      {{ success }}
    </div>

    <div class="alert alert-danger" role="alert" v-if="error">{{ error }}</div>

    <table
      class="table xtable-responsive table-striped xtable-fixed table-sm"
      v-if="tareasBusqueda && tareasBusqueda.data.length"
    >
      <thead>
        <tr>

          <th
            @click="orderByfield('tarea')"
            class="tablesorter-header"
            :class="orderClass('tarea')"
            scope="col"
          >
            Tarea
          </th>
          <th
            @click="orderByfield('inicio')"
            class="tablesorter-header"
            :class="orderClass('inicio')"
            scope="col"
          >
           Inicio
          </th>
          <th
            @click="orderByfield('activo')"
            class="tablesorter-header"
            :class="orderClass('activo')"
            scope="col"
          >
            Estado
          </th>

          <th
            @click="orderByfield('fin')"
            class="tablesorter-header"
            :class="orderClass('fin')"
            scope="col"
          >
            Fin
          </th>
          <th scope="col" width="110">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="tareaItem of tareasBusqueda.data"
          v-bind:key="tareaItem.id_tarea"
        >
                    <td style="text-align: left">{{ tareaItem.tarea }}</td>

                    <td v-if="tareaItem.created_at">
           {{ tareaItem.created_at }}
          </td>
          <td v-if="!tareaItem.created_at">
            ...
          </td>
          <td >
           <span :class="['align-middle badge  ', 
           (tareaItem.status == 'En Proceso' ? 'badge-info' : 'badge-secondary'),
           (tareaItem.status == 'Completado' ? 'badge-success' : 'badge-secondary'),
           (tareaItem.status == 'Finalizada con errores' ? 'badge-danger' : 'badge-secondary'),

           ]"> {{ tareaItem.status }}</span>
          </td>

           <td v-if="tareaItem.updated_at">
           {{ tareaItem.updated_at }}
          </td>
          <td v-if="!tareaItem.updated_at">
            ...
          </td>
          <td>
            <nobr>
          <button
                :class="['mr-2 btn btn-sm pt-0 pb-1', (tareaItem.status != 'En Proceso' ? 'btn-success' : 'btn-default'), (tareaItem.file_download ? 'btn-info' : '')]"

               
                data-toggle="tooltip"
                data-placement="top"

                :disabled= "tareaItem.status == 'En Proceso'"
                 :title="
                  tareaItem.status != 'En Proceso' ? 'Ejecutar Tarea'
                    : 'Aguarde que la tarea se complete'
                "              
                @click="showEdit(tareaItem, 'add')"
              >
                 <small
                  :class="['bi ', (tareaItem.file_download ? 'bi-arrow-repeat' : 'bi-play')]"
                ></small>
              </button>
              <button 
                type="button"
                @click="downloadTareaFile(tareaItem)"
                :class="['btn btn-sm pt-0 pb-1', (tareaItem.file_download ? 'btn-success' : 'btn-default disabled'), 
                (tareaItem.status == 'Finalizada con Errores' ? 'btn-danger' : '')
                ]"
                :style="tareaItem.file_download ? 'color:white' : 'color:gray'"
                data-toggle="tooltip"
                data-placement="top"
                :title="
                  tareaItem.file_download ? tareaItem.message
                    : 'Aguarde que la tarea se complete'
                "
                :disabled="!tareaItem.file_download"
              >
                <small class="bi bi-download"></small>
              </button>
            </nobr>
          </td>
        </tr>
      </tbody>
    </table>
    <Paginador
      v-if="tareasBusqueda && tareasBusqueda.pages"
      :pages="tareasBusqueda.pages"
      @selPage="changePage"
    ></Paginador>
    <div
      v-if="
        !(
          tareasBusqueda &&
          tareasBusqueda.data &&
          tareasBusqueda.data.length
        ) && post
      "
    >
      <div class="alert alert-info">
       No existen tareas para el usuario
      </div>
    </div>

    <div v-if="error">{{ error.message }}</div>

    <!-- Modal -->
    <div v-if="showModal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div
              class="modal-dialog modal-dialog-scrollable"
              role="document"
              :class="
                operation == 'jerarquia'
                  ? 'modal-lg modal-dialog-scrollable'
                  : ''
              "
            >
              <div class="modal-content">
                <div class="modal-header">

                  <h5 class="modal-title">
                    Nueva Tarea
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    @click="closeModal"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <form v-if="operation == 'edit' || operation == 'add'">
                 

                          <p v-if="editData.file_download">Esta tarea ya posee un archivo generado, al volver a ejecutarla ese archivo se reemplazara por el nuevo</p>
                      <p v-if="!editData.file_download">A continuación se comenzara a ejecutar la tarea, una vez finalizada se podrá descargar el archivo en esta misma sección</p>

                      <p v-if="editData.id_tarea > 7">Esta tarea requiere de un archivo .CSV, carguelo a continuación para analizar la información antes de comenzar el proceso</p>

                       <div v-if="editData.id_tarea == 2">

                        Seleccione que atributos contendra el listado

<div class="form-check">
  <input class="form-check-input" type="radio"  v-model="editData.atributoListado" id="atributoListado2" value="SERVICIOS" checked>
  <label class="form-check-label" for="atributoListado2">
    Todos
  </label>
</div>
<div class="form-check">
  <input class="form-check-input" type="radio"  v-model="editData.atributoListado" id="atributoListado2" value="TRYANDBUY" checked>
  <label class="form-check-label" for="atributoListado2">
    Try and buy
  </label>
</div>
<div class="form-check">
  <input class="form-check-input" type="radio"  v-model="editData.atributoListado" id="atributoListado3" value="TAIL" >
  <label class="form-check-label" for="atributoListado3">
    Colitas
  </label>
</div>
<div class="form-check">
  <input class="form-check-input" type="radio"  v-model="editData.atributoListado" id="atributoListado4" value="PIN" >
  <label class="form-check-label" for="atributoListado4">
    Mensajes de PIN
  </label>
</div>
<div class="form-check">
  <input class="form-check-input" type="radio"  v-model="editData.atributoListado" id="atributoListado5" value="BILLING" >
  <label class="form-check-label" for="atributoListado5">
    Configuracion cobros
  </label>
</div>
</div>
                      
                      
                  
        


                    <span v-if="editData.id_tarea == 8">

                      <a target ="_blank" href="/storage/plantillaPaymentsBulk.csv"><b style="font-size: 12px; float: right;">Descargar archivo ejemplo Payments</b></a><br><br>
                      
                    <div class="form-group">
                      <label>Archivo</label><br>
                          <vue-csv-import
      v-model="csv"
      :autoMatchFields="true"
      :autoMatchIgnoreCase="true"
      :headers="true"
      :map-fields="['idLista', 'idPayment', 'idMedio','precioSinImpuestos','precioConImpuestos','descripcion','avance']"
    >
    <template slot="thead">
        <tr>
            <th>Campos</th>
            <th>Columnas</th>
        </tr>
    </template>
    <template slot="next" slot-scope="{load}">
        <button class="btn btn-primary" @click.prevent="load">Procesar Archivo</button>
    </template>
    </vue-csv-import>

                    </div>
                    </span>
                    <span v-if="editData.id_tarea == 9">
                         <a target ="_blank" href="/storage/plantillaKeywordsBulk.csv"><b style="font-size: 12px; float: right;">Descargar archivo ejemplo Keywords</b></a><br><br>
                      
                    <div class="form-group">
                      <label>Archivo</label><br>
                          <vue-csv-import
      v-model="csv"
      :autoMatchFields="true"
      :autoMatchIgnoreCase="true"
      :headers="true"
      :map-fields="['keyword']"
    >
    <template slot="thead">
        <tr>
            <th>Campos</th>
            <th>Columnas</th>
        </tr>
    </template>
    <template slot="next" slot-scope="{load}">
        <button class="btn btn-primary" @click.prevent="load">Procesar Archivo</button>
    </template>
    </vue-csv-import>

                    </div>
                    </span>
                    <div v-if="errors" class="alert alert-danger" role="alert">
                      {{ errors }}
                    </div>
                  </form>
                  <p v-if="operation == 'toggle'">
                    Esta seguto de realizár esta acción?
                  </p>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    @click="closeModal"
                  >
                    <span v-if="operation == 'jerarquia'">Cerrar</span>
                    <span v-else>Cancelar</span>
                  </button>
                  <button
                    type="button"
                    v-if="operation == 'toggle'"
                    @click="toggleStatus"
                    class="btn btn-primary"
                  >
                    <span v-if="editData.activo == 1"> Suspender</span>
                    <span v-if="editData.activo == 0"> Reactivar</span>
                  </button>
                
                  <button
                    type="button"
                    @click="procesaTarea(editData.entidad,editData.metodo)"
                    class="btn btn-primary"
                  >
                  Procesar Tarea
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Paginador from "./Paginador.vue";
import { VueCsvImport } from "vue-csv-import";
import { triggerDownload } from "@/services/notificationService";
import { tableSortMixin } from "@/mixins/tableSortMixin";

export default {
  name: "Tareas",
  mixins: [tableSortMixin],

  data() {
    return {
      success: null,
      error: null,
      id_integrador_sel: localStorage.getItem("integrador"),
      tarea_sel: null,
      tareasBusqueda: null,
      tarea_activo: null,
      post: false,
      showModal: false,
      editData: null,
      operation: null,
      page: 1,
      errors: [],
      pages: null,
      csv:null,
    };
  },

  components: {
    Paginador,
    VueCsvImport
  },

  created() {
    this.getTareasBusqueda();
  },

  mounted() {
    window.addEventListener("genesis-task-completed", this.handleRealtimeTaskUpdate);
    window.addEventListener("genesis-task-failed", this.handleRealtimeTaskUpdate);
  },

  beforeDestroy() {
    window.removeEventListener("genesis-task-completed", this.handleRealtimeTaskUpdate);
    window.removeEventListener("genesis-task-failed", this.handleRealtimeTaskUpdate);
  },

  computed: {
    ...mapGetters("auth", ["user"]),
  },

  methods: {
    tareasBuscar: function () {
      this.changePage(1);
    },

    changePage: function (page) {
      this.page = page;
      this.getTareasBusqueda(false);
    },

    orderByfield: function (field) {
      this.toggleOrder(field);
      this.getTareasBusqueda(false);
    },

    getTareasBusqueda: function (hideResult = true) {
      if (hideResult) this.tareasBusqueda = null;
      this.post = false;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "tarea/busqueda", {
          page: this.page,
          integrador: this.id_integrador_sel,
          tarea: this.tarea_sel,
          activo: this.tarea_activo,
          order_by: { field: this.orderByField, order: this.orderByDirection },
        })
        .then((response) => {
          this.tareasBusqueda = response.data;
        })
        .catch((e) => {
          this.errors.push(e);
           if (e.response.status==429) {
          Swal.fire({
            title: "Error!",
            text: "Espere un momento y vuelva a intentarlo.",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
          }else{
          Swal.fire({
            title: "Error!",
            text: "Ha ocurrido un error al buscar las tareas",
            icon: "error",
            confirmButtonText: "Aceptar",
          });}
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },

    showEdit: function (item, operation) {
      this.errors = null;
      this.editData = Object.assign({}, item);

      this.showModal = true;
      this.operation = operation;
    },

    handleRealtimeTaskUpdate: function () {
      this.getTareasBusqueda(false);
    },

    procesaTarea: function (entidad, metodo) {
      this.errors = null;
      this.editData.id_integrador = parseInt(
        localStorage.getItem("integrador")
      );

      const target_id = this.editData.id_tarea;
      const targetTitle = this.editData.tarea || entidad;

      // Cerrar modal inmediatamente para no bloquear al usuario
      this.showModal = false;
      this.operation = null;

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "info",
        title: `Procesando "${targetTitle}" en segundo plano...`,
        text: "Te avisaremos cuando finalice. Puedes seguir navegando.",
        showConfirmButton: false,
        timer: 4000,
        timerProgressBar: true
      });

      axios
        .post(
          process.env.VUE_APP_API_URL + "tarea/procesar",
          {
            id_tarea: target_id,
            entidad: entidad,
            metodo: metodo,
            integrador: this.editData.id_integrador,
            atributo: this.editData.atributoListado,
            file: this.csv
          },
          {
            skipLoading: true,
            headers: { "X-Skip-Loading": "true" }
          }
        )
        .then(() => {
          this.editData = null;
          this.csv = null;
          // Refrescar listado para mostrar la tarea 'En Proceso'
          this.getTareasBusqueda(false);
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            Swal.fire({
              title: "Error!",
              text: e.response.data.error,
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar procesar la tarea",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
          this.getTareasBusqueda(false);
        });
    },

    downloadTareaFile: function (tareaItem) {
      if (!tareaItem) return;
      let downloadTarget = tareaItem.file_download;
      if (!downloadTarget && tareaItem.id_tarea) {
        downloadTarget = `/api/export/download/${tareaItem.id_tarea}`;
      }
      if (!downloadTarget) return;

      const isTxt = String(downloadTarget).endsWith('.txt') || String(downloadTarget).endsWith('.log');
      const ext = isTxt ? 'txt' : 'xlsx';
      const defaultFilename = `${tareaItem.tarea || tareaItem.entidad || 'Tarea'}.${ext}`;
      triggerDownload(downloadTarget, defaultFilename);
    },

    toggleStatus: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      this.editData.activo = 1 - this.editData.activo;
      axios
        .post(process.env.VUE_APP_API_URL + "tarea/update", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            Swal.fire({
              title: "Bien!",
              text: "tarea actualizada correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getTareasBusqueda();
        });
    },

    closeModal() {
      this.showModal = false;
      this.operation = null;
    },
  },
};
</script>

<style scoped></style>
